module.exports = __webpack_public_path__ + "img/nogoipcap-min.84c5a23c.jpg";